import { CONFIG } from 'src/config';
import { FileUploadPickOptions, pickFileAndUpload } from 'src/guestFile';
import { generateUUID } from 'src/helpers/utils';
import { getLocale } from 'src/translations/i18n';
import { GuestInfo, GuestType, isGuestOfTypes } from 'src/user';

export const ALLOWED_GUEST_TYPES_FOR_PICTURE_UPDATE = ['instructor', 'trainee'] as const satisfies GuestType[];

/**
 * Check whether a guest type is allowed to updated its picture.
 * @param guestInfo Guest info to check.
 * @returns Whether the given type is allowed.
 */
export function isGuestAllowedToUpdatePicture(guestInfo?: GuestInfo) {
  return isGuestOfTypes(guestInfo, ALLOWED_GUEST_TYPES_FOR_PICTURE_UPDATE);
}

/**
 * Upload a new guest picture, replacing the previous one.
 * @param academyId User Code / Academy ID of the guest.
 * @param guestType Type of guest whose picture is changed.
 * @returns A promise tied to the file upload.
 */
export async function uploadGuestPicture(academyId: string | number, guestType: GuestType) {
  return pickFileAndUpload(getDefaultPickerOptions(academyId, guestType));
}

function getStoragePath(academyId: string | number, guestType: GuestType) {
  switch (guestType) {
    case 'instructor':
      return `/users/${academyId}/instructor_logos/${generateUUID()}/`;
    case 'trainee':
      return `/users/${academyId}/trainees_logos/${generateUUID()}/`;
  }
}

function getDefaultPickerOptions(academyId: string | number, guestType: GuestType) {
  return {
    lang: getLocale(),
    accept: ['.jpg', '.png'],
    imageMax: [1920, 1200],
    storeTo: {
      location: 'S3',
      container: CONFIG.s3Bucket,
      path: getStoragePath(academyId, guestType),
      region: 'eu-west-1',
    },
  } satisfies FileUploadPickOptions;
}
